// Theme: sakura
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'sakura',
  name: 'SAKURA',
  tagline: 'SAKURA',
  description: 'Sakura classico em base clara com contraste suave para leitura.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#FFF7FB', '#FFF0F7', '#F582C4', '#4A2E43'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(245, 130, 196, 0.06)',
      '--shadow-card-active': '0 14px 34px rgba(245, 130, 196, 0.08)'
    },
    shellClasses: 'font-sans theme-sakura'
  },
  colorVars: {
    '--accent': '#F5A8D4',
    '--accent-foreground': '#3D1F33',
    '--background': '#FFF7FB',
    '--border': '#EABAD2',
    '--card': '#FFF0F7',
    '--card-border-active': 'rgba(245, 130, 196, 0.38)',
    '--card-completed': '#F8E3EF',
    '--card-foreground': '#4A2E43',
    '--card-glow': 'rgba(245, 130, 196, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': 'oklch(0.99 0.005 326)',
    '--foreground': '#4A2E43',
    '--hold-fill': '#F582C4',
    '--input': '#F3D4E5',
    '--modal-bg': '#FFF7FB',
    '--modal-border': '#EABAD2',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(245, 130, 196, 0.06)',
    '--muted': '#F3D4E5',
    '--muted-foreground': '#7D4F67',
    '--nav-active': '#F582C4',
    '--nav-bg': '#FFEFF7',
    '--popover': '#FFF0F7',
    '--popover-foreground': '#4A2E43',
    '--primary': '#F582C4',
    '--primary-foreground': '#3D1F33',
    '--ring': '#F582C4',
    '--secondary': '#EABAD2',
    '--secondary-foreground': '#4A2E43',
    '--streak': '#F582C4',
    '--success': '#22c55e',
    '--success-foreground': 'oklch(0.99 0.005 326)',
    '--xp': '#F582C4',
    '--xp-bg': '#F3D4E5'
  },
  resolvedVars: {
    '--accent': '#F5A8D4',
    '--accent-foreground': '#3D1F33',
    '--accent-foreground-hsl': '320 33% 18%',
    '--accent-foreground-oklch': 'from #3D1F33 l c h',
    '--accent-hsl': '326 79% 81%',
    '--accent-oklch': 'from #F5A8D4 l c h',
    '--background': '#FFF7FB',
    '--background-hsl': '330 100% 98%',
    '--background-oklch': 'from #FFF7FB l c h',
    '--border': '#EABAD2',
    '--border-hsl': '330 53% 82%',
    '--border-oklch': 'from #EABAD2 l c h',
    '--border-w': '1px',
    '--card': '#FFF0F7',
    '--card-border-active': 'rgba(245, 130, 196, 0.38)',
    '--card-completed': '#F8E3EF',
    '--card-completed-hsl': '326 60% 93%',
    '--card-completed-oklch': 'from #F8E3EF l c h',
    '--card-foreground': '#4A2E43',
    '--card-foreground-hsl': '315 23% 24%',
    '--card-foreground-oklch': 'from #4A2E43 l c h',
    '--card-glow': 'rgba(245, 130, 196, 0.06)',
    '--card-hsl': '332 100% 97%',
    '--card-oklch': 'from #FFF0F7 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': 'oklch(0.99 0.005 326)',
    '--destructive-foreground-hsl': '0 0% 100%',
    '--destructive-foreground-oklch': '0.99 0.005 326',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#4A2E43',
    '--foreground-hsl': '315 23% 24%',
    '--foreground-oklch': 'from #4A2E43 l c h',
    '--hold-fill': '#F582C4',
    '--hold-fill-hsl': '326 85% 74%',
    '--hold-fill-oklch': 'from #F582C4 l c h',
    '--input': '#F3D4E5',
    '--input-hsl': '327 56% 89%',
    '--input-oklch': 'from #F3D4E5 l c h',
    '--modal-bg': '#FFF7FB',
    '--modal-bg-hsl': '330 100% 98%',
    '--modal-bg-oklch': 'from #FFF7FB l c h',
    '--modal-border': '#EABAD2',
    '--modal-border-hsl': '330 53% 82%',
    '--modal-border-oklch': 'from #EABAD2 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(245, 130, 196, 0.06)',
    '--muted': '#F3D4E5',
    '--muted-foreground': '#7D4F67',
    '--muted-foreground-hsl': '329 23% 40%',
    '--muted-foreground-oklch': 'from #7D4F67 l c h',
    '--muted-hsl': '327 56% 89%',
    '--muted-oklch': 'from #F3D4E5 l c h',
    '--nav-active': '#F582C4',
    '--nav-active-hsl': '326 85% 74%',
    '--nav-active-oklch': 'from #F582C4 l c h',
    '--nav-bg': '#FFEFF7',
    '--nav-bg-hsl': '330 100% 97%',
    '--nav-bg-oklch': 'from #FFEFF7 l c h',
    '--popover': '#FFF0F7',
    '--popover-foreground': '#4A2E43',
    '--popover-foreground-hsl': '315 23% 24%',
    '--popover-foreground-oklch': 'from #4A2E43 l c h',
    '--popover-hsl': '332 100% 97%',
    '--popover-oklch': 'from #FFF0F7 l c h',
    '--primary': '#F582C4',
    '--primary-foreground': '#3D1F33',
    '--primary-foreground-hsl': '320 33% 18%',
    '--primary-foreground-oklch': 'from #3D1F33 l c h',
    '--primary-hsl': '326 85% 74%',
    '--primary-oklch': 'from #F582C4 l c h',
    '--radius': '12px',
    '--ring': '#F582C4',
    '--ring-hsl': '326 85% 74%',
    '--ring-oklch': 'from #F582C4 l c h',
    '--secondary': '#EABAD2',
    '--secondary-foreground': '#4A2E43',
    '--secondary-foreground-hsl': '315 23% 24%',
    '--secondary-foreground-oklch': 'from #4A2E43 l c h',
    '--secondary-hsl': '330 53% 82%',
    '--secondary-oklch': 'from #EABAD2 l c h',
    '--shadow-card': '0 12px 30px rgba(245, 130, 196, 0.06)',
    '--shadow-card-active': '0 14px 34px rgba(245, 130, 196, 0.08)',
    '--streak': '#F582C4',
    '--streak-hsl': '326 85% 74%',
    '--streak-oklch': 'from #F582C4 l c h',
    '--success': '#22c55e',
    '--success-foreground': 'oklch(0.99 0.005 326)',
    '--success-foreground-hsl': '0 0% 100%',
    '--success-foreground-oklch': '0.99 0.005 326',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(326 85% 74% / 0.15)',
    '--xp': '#F582C4',
    '--xp-bg': '#F3D4E5',
    '--xp-bg-hsl': '327 56% 89%',
    '--xp-bg-oklch': 'from #F3D4E5 l c h',
    '--xp-hsl': '326 85% 74%',
    '--xp-oklch': 'from #F582C4 l c h'
  }
}
